import { render, staticRenderFns } from "./Bandeiras.vue?vue&type=template&id=888b5812&scoped=true&"
import script from "./Bandeiras.vue?vue&type=script&lang=js&"
export * from "./Bandeiras.vue?vue&type=script&lang=js&"
import style0 from "./Bandeiras.vue?vue&type=style&index=0&id=888b5812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888b5812",
  null
  
)

export default component.exports